import React, { useState, useEffect, useRef } from "react";
import { handleUnauthorized } from "../../../src/utils/apiHelper";
import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import Loader from "./../child/Loder";

const ViewFAQPageNew = () => {
  const [userData, setUserData] = useState(null); // State to store user details
  const [loading, setLoading] = useState(true); // State to handle loading
  const { id } = useParams();
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
  useEffect(() => {
    const fetchUserData = async () => {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/faqById/${id}`;
      try {
        setLoading(true);
        const authToken = localStorage.getItem("authToken");

        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 401) {
          handleUnauthorized(navigate);
          return;
        }
        const data = await response.json();
        setUserData(data.result);
      } catch (err) {
        setErrorMessage(err.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);
  if (loading) return <Loader />;
  return (
    <div className="row gy-4">
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
      {errorMessage && (
        <DengerAlert
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <span>
              <b>{userData?.question || "N/A"}</b>
            </span>
            <p> {userData?.answer || "N/A"}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewFAQPageNew;
